// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { HOME_ROUTE } from '../app/shared/constants/constants';

export const environment = {
  name: 'staging',
  production: false,
  baseUrl: 'https://grens-mock-be.dotitsrl.it/api/v1',
  home: HOME_ROUTE,
  defaultLanguage: 'it',
  gtmId: 'GTM-XXXXXX'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
